import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilService } from '../common/util.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'platform-integration-banner',
  imports: [CommonModule, TranslateModule, MatButtonModule, MatIconModule],
  templateUrl: './integrations-banner.component.html',
  styleUrl: './integrations-banner.component.scss',
})
export class IntegrationsBannerComponent implements OnInit {
  private readonly cookieService = inject(CookieService);
  private readonly utilService = inject(UtilService);

  protected readonly jobberLogo = this.utilService.getImageSrc('jobber_logo.png');
  protected readonly housecallproLogo = this.utilService.getImageSrc('house_call_pro.png');
  protected readonly petResortProLogo = this.utilService.getImageSrc('pet_resort_pro_logo.png');
  isIntegrationsBannerDismissed = false;

  @Output() navigateToBrowse = new EventEmitter<boolean>();

  ngOnInit(): void {
    this.isIntegrationsBannerDismissed = Boolean(this.cookieService.get('integrations-banner-dismissed'));
  }

  dismissBanner() {
    this.cookieService.set('integrations-banner-dismissed', 'true', 0, '/');
    this.isIntegrationsBannerDismissed = true;
  }

  navigateToBrowseButton() {
    this.navigateToBrowse.emit(true);
  }
}
